import { render, staticRenderFns } from "./AreasComponent.vue?vue&type=template&id=0a58726c"
import script from "./AreasComponent.vue?vue&type=script&lang=js"
export * from "./AreasComponent.vue?vue&type=script&lang=js"
import style0 from "./AreasComponent.vue?vue&type=style&index=0&id=0a58726c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports